import { CRUDEntity } from "../../abstracts/CRUDEntity";

export class IntegrationsList extends CRUDEntity{
    constructor(){
        super();
        this.entityClass = 'integrations-list';
        this.urlRoot = '/settings/integrations-list';
        this.sectionRootUrl = '/settings';

    }
}
